// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__tHGVQ","footer":"ReportModalFilter_footer__mUxSA"};